import { guid } from '../../../server/helper'

// These enums must be synced with relevant SCSS variables
export const ADBLOCKER_ELEMENT_PLACEHOLDER = {
  BANNER_SPACE_ALLOCATOR: 'guid-7e1cdb51',
  MOBILE_MODIFIER: 'guid-cd769b05',
  TABLET_MODIFIER: 'guid-c8964dcf',
  DESKTOP_SM_MODIFIER: 'guid-e4fd7f2f',
  DESKTOP_MD_MODIFIER: 'guid-c8885c1f',
  DESKTOP_LG_MODIFIER: 'guid-f0c2aab8',
  DESKTOP_XL_MODIFIER: 'guid-5b2c1cbe',
  ABOVE_DESKTOP_XL_MODIFIER: 'guid-4f49c294',
  SPONSORED_ARTICLE_INDICATOR: 'guid-ba5e02e6'
}

const ADBLOCKER_ELEMENT_DYNAMIC_VALUE_TEMPLATE = {
  [ADBLOCKER_ELEMENT_PLACEHOLDER.BANNER_SPACE_ALLOCATOR]: null,
  [ADBLOCKER_ELEMENT_PLACEHOLDER.MOBILE_MODIFIER]: null,
  [ADBLOCKER_ELEMENT_PLACEHOLDER.TABLET_MODIFIER]: null,
  [ADBLOCKER_ELEMENT_PLACEHOLDER.DESKTOP_SM_MODIFIER]: null,
  [ADBLOCKER_ELEMENT_PLACEHOLDER.DESKTOP_MD_MODIFIER]: null,
  [ADBLOCKER_ELEMENT_PLACEHOLDER.DESKTOP_LG_MODIFIER]: null,
  [ADBLOCKER_ELEMENT_PLACEHOLDER.DESKTOP_XL_MODIFIER]: null,
  [ADBLOCKER_ELEMENT_PLACEHOLDER.ABOVE_DESKTOP_XL_MODIFIER]: null,
  [ADBLOCKER_ELEMENT_PLACEHOLDER.SPONSORED_ARTICLE_INDICATOR]: null
}

function generateUniqueId(existingIds = []) {
  let id
  do {
    id = `guid-${guid().match(/[\d\w]*/)[0]}`
  } while (existingIds.includes(id))

  return id
}

function fillDynamicValues(obj) {
  const usedIds = []
  const resultObject = {}

  for (const key in obj) {
    const uniqueId = generateUniqueId(usedIds)
    resultObject[key] = uniqueId
    usedIds.push(uniqueId)
  }

  return resultObject
}

export const ADBLOCKER_ELEMENT_DYNAMIC_VALUE_BY_PLACEHOLDER = fillDynamicValues(
  ADBLOCKER_ELEMENT_DYNAMIC_VALUE_TEMPLATE
)
